import { useTranslation } from "react-i18next";
import { Notebook } from "@phosphor-icons/react";
import { ModuleNavBar } from "../components/ModuleNavBar";
import { GlobalNoteBox } from "../components/GlobalNoteBox";

// Dedicated full-page view of the same account-wide Global Note shown
// inline on the Tasks page sidebar - this is what the "复制链接" button's
// URL (`/global-note`) points at, so pasting that link into another app
// (or a new browser tab) jumps straight to a focused editing surface
// instead of the whole Tasks page. Requires login like every other module
// (ProtectedRoute in App.js) - not a public/token-based link.
export default function GlobalNotePage() {
  const { t } = useTranslation();

  return (
    <div className="h-screen flex flex-col bg-background" data-testid="global-note-page">
      <ModuleNavBar />
      <div className="flex-1 overflow-hidden p-6 md:p-10">
        <div className="max-w-4xl mx-auto w-full h-full flex flex-col">
          <h1 className="font-display text-3xl font-black tracking-tight flex items-center gap-3 mb-6 shrink-0">
            <Notebook size={28} /> {t("globalNote.title")}
          </h1>
          <div className="flex-1 min-h-0">
            <GlobalNoteBox className="h-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
